export default {
  createValueAddedActivity: '/valueAddedActivity/createValueAddedActivity',
  getValueAddedActivityAll: '/valueAddedActivity/getValueAddedActivityAll',
  getAllValueAddedActivityOfInstitute: '/valueAddedActivity/getAllValueAddedActivityOfInstitute',
  getValueAddedActivity: '/valueAddedActivity/getValueAddedActivity',
  updateValueAddedActivity: '/valueAddedActivity/updateValueAddedActivity',
  deleteValueAddedActivity: '/valueAddedActivity/deleteValueAddedActivity',
 
}